import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchCustomerDetails, getRacketFreeEligibility } from "../api";

export default function RestringingRouter() {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Authentication token not found.");

        const response = await fetchCustomerDetails(token);
        const data = response?.data || {};

        const serviceClaims = Array.isArray(data.service_claims)
          ? data.service_claims
          : [];

        if (serviceClaims.length === 0) {
          navigate("/customer/dashboard/booking-form", { replace: true });
          return;
        }

        const claimsWithRemaining = serviceClaims.filter((claim) => {
          const total = claim?.total_free_services ?? 0;
          const used = claim?.used_services ?? 0;
          return total - used > 0;
        });

        if (claimsWithRemaining.length === 0) {
          navigate("/customer/dashboard/booking-form", { replace: true });
          return;
        }

        const uniqueRpIds = [
          ...new Set(claimsWithRemaining.map((c) => c.rp_id).filter(Boolean)),
        ];

        const eligResults = await Promise.all(
          uniqueRpIds.map(async (rpId) => {
            try {
              const res = await getRacketFreeEligibility(rpId);
              return { rpId, eligible: !!res?.eligible };
            } catch {
              return { rpId, eligible: false };
            }
          })
        );

        const hasAnyFreeNow = eligResults.some((r) => r.eligible === true);

        if (hasAnyFreeNow) {
          navigate("/customer/dashboard/stringing-services", { replace: true });
        } else {
          navigate("/customer/dashboard/booking-form", { replace: true });
        }
      } catch (e) {
        navigate("/customer/dashboard/booking-form", { replace: true });
      }
    })();
  }, [navigate]);

  return null;
}
